import { createLoanApplication } from '@sec-loans-ui/common/api/endpoints'
import { SecLoansCreateApplicationRequest, SecLoansCreateApplicationResponse } from '@shared/sec-loans'

import { createNewApplicationMachine } from '../newApplicationMachine'

export type NewLoanApplicationMachineType = ReturnType<
  typeof createNewApplicationMachine<SecLoansCreateApplicationRequest, SecLoansCreateApplicationResponse>
>
export const createNewLoanApplicationMachine = (): NewLoanApplicationMachineType =>
  createNewApplicationMachine('newLoanApplicationMachine', createLoanApplication)
